import React, { Component } from 'react';
import { connect } from 'react-redux';
import { choseBankIndex,choseCurrentIndex ,choseBankOrCurrent} from '../../../action/productAction';
import Util from '../../../util';
import { hashHistory } from 'react-router';
import NavigatorMain from '../../NavigatorMain';
import {bankCode} from '../../../BankCode';
import store from '../../../ReduxStore.js';
import {
  getPayAll,
  goLogin
} from '../../../getPay';
// import { findCamcHqtExist } from '../../../action/myAssets/userInfoAction'
import { getCardList } from '../../../action/myAssets/myCardAction'
import { getTempInfo } from '../../../common.js';
class PayCard extends Component {
  constructor(props) {
    super(props);
    this.state = {

  
    };
  }
  componentWillMount() {
  }
  toGetCardList = async () => {
    let params = {
      token: await getTempInfo('shortToken'),
    }
    store.dispatch(getCardList(params, (content)=>{ console.log(content) }, (msg)=> { console.log(msg) } ))
  }
  componentDidMount(){
    // let data = store.getState().verifiedUserInfo.content;
    // console.log(data)
    // let inParamsData = {
    //   certNo: data.certNo,
    //   certType: data.certType,
    //   name: data.name
    // }
    // store.dispatch(findCamcHqtExist(inParamsData))
    this.toGetCardList();
  }
  choseBank(){
    hashHistory.push({
      pathname: '/PayCardList',
      state:{
        type:this.props.type,
        actionType:this.props.actionType,
        fundCode:this.props.superFundCode
      }
    });
  }
  renderRecharge(){
    let {payInfoData}=this.props;
    if (payInfoData.currentType==2)
      // if (false)
      return(
        <div className='render_recharge'>
          {
            payInfoData.currentType==2?<div onClick={()=>this.goHQT(payInfoData.content.shareList[payInfoData.currentIndex])}>
              {`存入活期通 >`}
            </div>:
            <div onClick={()=>this.goLQB(payInfoData.content.currencyFund[payInfoData.currentIndex])}>
              {`存入零钱宝 >`}
            </div>
          }
        </div>
      )
    else 
      return (
        <div style={{height:10}}></div>
      )
  }
  goHQT(parmas){
    let { navigator ,dispatch,fundCode} = this.props;
    let data={
      fundCode:'003003',
      businessType:'T022',
      productType:'G',
      type:this.props.type,
      bankAccountShowNo:parmas.bankAccountShowNo,
    }
    getPayAll( window.history.length, data, hashHistory, 'RechargeHqt')
  }
  render(){
    const { 
      payInfoData
    }=this.props;
    console.log(payInfoData);
    return (
        <div>
          {
            payInfoData.currentType==1&&payInfoData.content.currentAccountList.length>0?payInfoData.content.currentAccountList.map( (item,i)=> {
              if (i==payInfoData.currentIndex) {
                if (item.disable) {
                  if (item.paymentChannel=='888') {
                    return(
                      <div key={`currentAccountList${i}`} onClick={()=>this.choseBank()} className='bankList' >
                        <img src={ require('../../../img/bank.png')}  className='img'/>
                        <div className='bankListTip'>
                          <p>理财中心</p>
                          <p>理财中心POS机刷卡</p>
                        </div>
                        <div className='bankListRight'>
                        </div>
                      </div>
                    )
                  }else{
                    return(
                      <div key={`currentAccountList${i}`} onClick={()=>this.choseBank()} className='bankList' >
                        <img src={ bankCode['ty'][item.bankCode]?bankCode['ty'][item.bankCode]:require('../../../img/bank.png')}  className='img'/>
                        <div className='bankListTip'>
                          <p>{Util.formatStr(item.bankName)+'(*'+Util.formatStr(item.bankAccountShowNo).substr(-4)+')'}</p>
                          <p>{window.funSplit(item.tradeMaxAmountTips)[1]}</p>
                        </div>
                        <div className='bankListRight'>
                        </div>
                      </div>
                    )
                  }
                }else{
                  return(
                    <div onClick={()=>this.choseBank()} style={{fontSize:15,height:'1.7rem',backgroundColor:'#fefefe',textAlign:'center',lineHeight:'1.7rem'}}>无支付方式</div>
                  )
                }
              } 
            }):payInfoData.currentType==2&&payInfoData.content.shareList.length>0?payInfoData.content.shareList.map( (item,i)=> {
              if (i==payInfoData.currentIndex) {
                if (item.disable) {
                  return(
                    <div key={`shareList${i}`} onClick={()=>this.choseBank()} className='bankList' >
                      {
                        item.paymentChannel=='888'?
                        <img src={ require('../../../img/bank.png')}  className='img'/>
                        :
                        <img src={ bankCode['ty'][item.bankCode]?bankCode['ty'][item.bankCode]:require('../../../img/bank.png')}  className='img'/>
                      }
                      
                      <div className='bankListTip'>
                        
                        {
                          item.paymentChannel=='888'?
                          <p>
                            <img src={require('../../../img/icon_hqt.png')} style={{width:28,height:20}}/>
                            活期通
                          </p>
                          :
                          <p>
                            <img src={require('../../../img/icon_hqt.png')} style={{width:28,height:20}}/>
                            {Util.formatStr(item.trustChannelName)+'(*'+Util.formatStr(item.bankAccountShowNo).substr(-4)+')'}
                          </p>
                        }
                        {
                          item.paymentChannel == "G000" && item.ywt == false ?
                          <p>招行卡暂不可用，请您去华夏基金管家App操作或咨询客服</p>
                          :
                          <p>{'可用余额:'+Util.parsePrice(item.availableVolume)}元</p>
                        }
                      </div>
                      <div className='bankListRight'>
                      </div>
                    </div>
                  )
                }else{
                  return(
                    <div onClick={()=>this.choseBank()} style={{fontSize:15,height:'1.7rem',backgroundColor:'#fefefe',textAlign:'center',lineHeight:'1.7rem'}}>无支付方式</div>
                  )
                }
              } 
            }):payInfoData.currentType==3&&payInfoData.content.currencyFund.length>0?payInfoData.content.currencyFund.map( (item,i)=> {
              if (i==payInfoData.currentIndex) {
                return(
                  <div key={`currencyFund${i}`}  className='bankList' onClick={()=>this.choseBank()}>
                    <img src={ require('../../../img/icon_LQB.png')} style={{width:36,height:40}} className='img'/>
                    <div className='bankListTip'>
                      <p>{item.fundName}<span style={{fontSize:12}}>{'('+Util.formatStr(item.trustChannelName)+'*'+Util.formatStr(item.bankAccountShowNo).substr(-4)+')'}</span></p>
                      <p>{'可用余额:'+Util.parsePrice(item.availableVolume)}元</p>
                    </div>
                    <div className='bankListRight'>
                    </div>
                  </div>
                )
              } 
            }):
            <div onClick={()=>this.choseBank()} style={{fontSize:15,height:'1.7rem',backgroundColor:'#fefefe',textAlign:'center',lineHeight:'1.7rem'}}>无支付方式</div>
            }
            {
              this.renderRecharge()
            }
        </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  console.log(state,ownProps);
  return {
    payInfoData:state[ownProps.type+'PayInfo']

  }
}
export default connect(mapStateToProps)(PayCard);



// WEBPACK FOOTER //
// ./src/components/myAssets/payment/PayCard.js